module.exports = __webpack_public_path__ + "statics/img/image2.b564f0d0.png";